// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__23LWj","selected":"Chip_selected__sEfyL"};